goog.provide('el8.ptdata.model.note.visitBulletSet');

goog.require('el8.ptdata.model.note.editableSet');
goog.require('el8.ptdata.model.note.baseBullet');
goog.require('el8.model.base');
goog.require('el8.util.base');


// ---------------------
// * VISIT NOTE BULLET *
// ---------------------
(function() {
    
    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8.ptdata.model.note.baseBullet);

    /* Fields that actually correspond to VisitNoteDocument on the 
     * server - which is collapsed into VisitNoteBullet's for the client
     *
     * Note: This is not on baseBullet because NonvisitNoteBullet's do not yet 
     * contain this information from NonvisitNoteDocument's. Those are still 
     * communicated to the client separately (in ownedDocuments and 
     * associatedDocuments properties of nonvisitNotes)
     */
    _class.addStringProperty("documentSummary", true);
    _class.addProperty("documentSummaryFormatting", true);
    _class.addBoolean('documentOwnedBy', true);  // whether associated document is owned or not

    _class.addStringProperty("patientSummary", true);
    _class.addProperty("patientSummaryFormatting", true);

    _class.addIntProperty('replacedById');
    _class.addIntProperty('replacedByEditId');
    _class.addIntProperty('editId');
    _class.addStringProperty("category", true);

    // if true, this field was edited by visit note template and will be colored differently
    _class.addBoolean('editedByVnt');

    _class.addImos();

    _class.prototype.populate = function(spec) {
        spec = spec || {};

        spec.imoIds = spec.imoIds || [];
        if (spec.imos && spec.imos.length) {
            el8.data.imos.create(spec.imos);
            spec.imoIds = _.pluck(spec.imos, 'id');
        }
        this.parent.populate.call(this, spec);

        var that = this;
        // All elements receive children, whether they can have them or not
        this.setChildrenSet(
            el8.ptdata.model.note.visitBulletSet(
                { category: that.getCategory(),
                  noteId: that.getNoteId(),
                  parentId: that.getId() },
                (spec['children'] || null)
            )
        );
    };

    // returns TRUE if this doesn't have a note id, which means this bulletset is not associated
    // with a note in the backend and exists only in the frontend.
    _class.prototype.isVirtual = function() {
        return !this.getNoteId();
    };

    /**
     * Return array of ICD-10 codes from all IMOs associated with this VNB, e.g. ["R05.3", "R05.9"]
     */
    _class.prototype.getIcd10Codes = function() {
        var icd10Codes = [];

        if (this.getImoIds().length > 0) {
            // Get directly associated ICD-10 codes from VNB rawData to avoid possible `el8.data.imos` stale cache 
            this.rawData.imos.forEach(function (imo) {
                imo.icd10_codes.forEach(function (code) {
                    icd10Codes.push(code);
                });
            });
        }

        return icd10Codes;
    };

    _class.prototype.getIdForUrl = function() {
        return this.getNoteId() + (this.getEditId() ? '-'+this.getEditId() : '');
    };

    // used in VisitNoteTemplate to serialize data to be saved to DB
    _class.prototype.getJsonData = function() {
        var data = {
            text: this.getText()
        };

        var imo_ids = this.getImoIds();
        if (imo_ids && imo_ids.length) {
            data['imo_ids'] = imo_ids;
        }
        var children = this.getChildrenSet().all();
        if (children && children.length) {
            data['children'] = [];
            children.forEach( function(child) {
                var childData = child.getJsonData();
                data['children'].push(childData);
            });
        }

        return data;
    }

    el8.ptdata.model.note.visitBullet = function(spec) {
        spec.model_class = "VisitNoteBullet";
        return new _class(spec);
    };

})();

el8.ptdata.model.note.visitBulletSet = function(setSpec, _data) {
    var _ajaxQueue = new el8.model.AjaxQueue();

    var _set = new el8.ptdata.model.note.editableSet({
        model: function(spec) {
            if (!spec.category) { spec.category = setSpec['category'] || null; }
            if (!spec.noteId) { spec.noteId = setSpec['noteId'] || null; }
            if (!spec.parentId) { spec.parentId = setSpec['parentId'] || null; }
            return el8.ptdata.model.note.visitBullet(spec);
        },
        sortFn: function(a, b) {
            // Sort in sequence
            return a.getSequence() - b.getSequence();
        },
        saveFn: function(item, successCb, errorCb, opts) {
            // don't save the item if it's virtual
            if (item.isVirtual()) {
                if (!item.getId()) {
                    item.setId(el8.util.generateRandomId());
                }
                this.add(item);
                if (successCb) {successCb(); }
                return;
            }

            var that = this;
            var async = (opts.async !== false); // defaults to true
            var saveArgs = {
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'visit-notes/'+item.getIdForUrl()+'/bullet/'+
                        (item.getId() ? 
                            item.getId()+'-'+item.getVersion()+'/' : ''),
                async: (opts.async !== false), // defaults to true
                data: {data: JSON.stringify(item.asMap())},
                success: function(data) {
                    // When we are amending a visit note, the server will send down a 
                    // replacement bullet with a different ID. We will just do a strict
                    // replace and then wait for the full "save" to sync up the entire
                    // history-complete visit note version. For now we just stay sync'd with 
                    // the "latest" most relevant version.
                    if (item.getId()) {
                        that.updateItemId(item, data.id);
                    } else {
                        item.setId(data.id);
                    }
                    item.populate(data);
                    that.sorted();
                    if (successCb) { successCb(); }
                },
                // Over-ride regular error behavior because we are expecting
                // the visit note lastDitchSave() to rescue everything
                error_override: function() {
                    if (errorCb) { errorCb(); }
                }
            };

            if (async) {
                var existingBulletVersion = item.getVersion() || 0;

                // Async bullet saves will go through an AjaxQueue to make sure we respect
                // the intended sequence. Synchronous saves will bypass the queue.
                //
                // Note that this is a slight abuse of the AjaxQueue, because one bullet save
                // does not replace another bullet save in the same queue. This means we cannot
                // trust the dirty flag for this AjaxQueue. It should still work for serialization.
                var queueName = (setSpec.category || '') + '-visit-bullets';
                _ajaxQueue.doAjax(queueName, saveArgs);

                // Eagerly update the bullet version so that if we personally initiate multiple
                // concurrent saves, the last one issued takes precedence (instead of creating
                // duplicates). Since we had knowledge of all the data, that should be ok.
                item.setVersion(existingBulletVersion + 1);
            } else {
                $.el8_ajax(saveArgs);
            }
        },
        deleteFn: function(item, successCb, errorCb) {
            // don't delete the item if it's virtual
            if (item.isVirtual()) {
                this.remove(item);
                return;
            }

            var that = this;
            $.el8_ajax({
                url: el8Globals['PATIENT_PATH']+'visit-notes/'+item.getIdForUrl()+'/bullet/'+
                        (item.getId() ? 
                            item.getId()+'-'+item.getVersion()+'/' : ''),
                type: 'DELETE',
                success: function(data) {
                    that.remove(item);
                    if (successCb) { successCb(); }
                },
                // Over-ride regular error behavior because we are expecting
                // the visit note lastDitchSave() to rescue everything
                error_override: function() {
                    if (errorCb) { errorCb(); }
                }
            });
        }
    });

    _set.sortedTextBullets = function() {
        return _set.sorted().filter(function(a) {
            return a.getText() || !a.getDocumentId(); // TODO do we want to use an explicit flag?
        });
    };

    _set.getTextReplacedById = function(replacedById) {
        var all = _set.all(true);
        for (var i=0; i<all.length; i++) {
            if (all[i].getReplacedById() === replacedById) {
                return all[i].getText();
            }
        }
        return null;
    };

    _set.asSingleField = function() {
        var separator = ';';
        var all = _set.sorted().map(function(a) { return a.getText(); });
        return all.join(separator+' ');
    };

    _set.getByReferencedDocId = function(docId) {
        var all = _set.all();
        // TODO probably an underscore method that does this better
        for (var i=0; i<all.length; i++) {
            if (all[i].getDocumentId() === docId*1) {
                return all[i];
            }
        }
        return null;
    };

    _set.getChildById = function(bulletId) {
        var all = _set.all();
        for (var i=0; i<all.length; i++) {
            var childrenSet = all[i].getChildrenSet();
            if (childrenSet && childrenSet.getById(bulletId)) {
                return childrenSet.getById(bulletId);
            }
        }
        return null;
    };

    // used by VisitNoteTemplate JSON serialization
    _set.getJsonData = function(onlyFirstBullet) {
        if (!_set.all().length) return [];
        
        if (onlyFirstBullet) {
            return [_set.sorted()[0].getJsonData()];
        } else {
            var data = [];
            var items = _set.sorted();
            var data = _.map(items, function(item) {
                return item.getJsonData();
            });
            return data;
        }
    }

    _set.create(_data);
    return _set;
};


